<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body"> </div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss('')"
    [translate]="'BUTTONS.CLOSE'"
  >
    <i class="fas fa-times"></i> Close</button
  >
  <button
    type="button"
    class="btn btn-primary"
    [ngClass]="{
      'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
    }"
    [disabled]="loading"
    (click)="setTags()"
  >
    <i class="fas fa-tags"></i> Set Tags
  </button>
</div>
